import { AnimatePresence, motion } from 'motion/react';
import { FaxTypes } from '@frontend/api-fax';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { EmptyContactsViewGraphic } from '../components/contacts/empty-contacts-view-graphic';
import { EmptyThreadViewGraphic } from '../components/thread-panel/empty-thread-view-graphic';
import { EndOfFaxesGraphic } from '../components/thread-panel/end-of-faxes-graphic';

type Props = {
  isAtEndOfInboxList: boolean;
  filter: FaxTypes.InboxType;
};

export const FaxThreadPanel = ({ filter, isAtEndOfInboxList }: Props) => {
  const { t } = useTranslation('fax');

  return (
    <section
      css={{
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        svg: { margin: theme.spacing(4) },
      }}
    >
      <AnimatePresence>
        {filter === FaxTypes.InboxType.ARCHIVED ? (
          <>
            <EndOfFaxesGraphic size={500} />
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
              <Text textAlign='center' color='light'>
                {t("You're in the archives.")}
              </Text>
            </motion.div>
          </>
        ) : (
          <>
            {filter === FaxTypes.InboxType.CONTACTS ? (
              <>
                <EmptyContactsViewGraphic size={500} />
                <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                  <Text textAlign='center' color='light'>
                    {t("Faxing is better with contacts. That's just fax.")}
                  </Text>
                </motion.div>
              </>
            ) : (
              <>
                {isAtEndOfInboxList ? (
                  <>
                    <EndOfFaxesGraphic size={500} />
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                      <Text textAlign='center' color='light'>
                        {t("You've reached the end of your faxes.")}
                      </Text>
                    </motion.div>
                  </>
                ) : (
                  <>
                    <EmptyThreadViewGraphic size={500} />
                    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                      <Text textAlign='center' color='light'>
                        {t('No fax selected.')}
                      </Text>
                      <Text textAlign='center' color='light'>
                        {t('Click on one to dive in.')}
                      </Text>
                    </motion.div>
                  </>
                )}
              </>
            )}
          </>
        )}
      </AnimatePresence>
    </section>
  );
};
